import { useEffect, useRef } from 'react';

// Calls `onClose` once per open-to-closed transition, whichever path closed the overlay;
// close handlers such as Escape can fire while it is already closed.
export const useOnClose = (isOpen: boolean, onClose: (() => void) | undefined): void => {
  const wasOpenRef = useRef(isOpen);
  useEffect(() => {
    if (wasOpenRef.current && !isOpen) {
      onClose?.();
    }
    wasOpenRef.current = isOpen;
  }, [isOpen, onClose]);
};
